import { useCallback, useMemo } from 'react';
import { Controller } from 'react-hook-form';
import find from 'lodash/find';

import { CurrencyMultiSelectValueType } from './components/CurrencySelectFieldControl/CurrencySelectFieldControl.types';

import { useTranslate } from '../../../common/hooks/useTranslate';

import {
  MultiSelectFieldControlProps,
  MultiSelectFieldProps
} from '../MultiSelectField';

import { CurrencySelectFieldControl } from './components/CurrencySelectFieldControl';

import { words } from '../../../locales/keys';

function CurrencySelectField<FormDataType>({
  classNamePrefix,
  control,
  defaultValue,
  disabled,
  error,
  i18nLabel,
  i18nPlaceholder,
  inputWrapperClassName,
  labelClassName,
  menuPosition = 'fixed',
  name,
  onChange: handleChange,
  withPortal
}: MultiSelectFieldControlProps<FormDataType> &
  MultiSelectFieldProps<FormDataType>) {
  const { t } = useTranslate();

  const options = useMemo(
    () => [
      { value: 'USD', label: t(words.usd) },
      { value: 'EUR', label: t(words.eur) },
      { value: 'GBP', label: t(words.gbp) },
      { value: 'AUD', label: t(words.aud) },
      { value: 'CAD', label: t(words.cad) },
      { value: 'UAH', label: t(words.uah) }
    ],
    [t]
  );

  const onChangeControl = useCallback(
    (value: string) => {
      const changedItem = find(options, (option) => option.value === value);
      handleChange?.(changedItem);
    },
    [handleChange, options]
  );

  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange, value, name },
        fieldState: { error: fieldError }
      }) => (
        <CurrencySelectFieldControl
          classNamePrefix={classNamePrefix || 'av_select'}
          data={options}
          defaultValue={defaultValue}
          disabled={disabled}
          error={fieldError?.message || error}
          i18nLabel={i18nLabel}
          i18nPlaceholder={i18nPlaceholder}
          inputWrapperClassName={inputWrapperClassName || 'w-full'}
          isSearchable
          labelClassName={labelClassName}
          menuPosition={menuPosition}
          multi={false}
          name={name}
          onChange={(value) => {
            onChange(value);
            onChangeControl?.(value);
          }}
          placeholder={i18nLabel}
          value={value as CurrencyMultiSelectValueType}
          withPortal={withPortal}
        />
      )}
    />
  );
}

export default CurrencySelectField;
